import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import QRScanner from '../../common/Scanner/QRScanner';

const SerialNumberValidation = () => {
  const dispatch = useDispatch();
  const { referenceId, stageData, isLoading } = useSelector(state => state.eligibility);
  const [serialNumber, setSerialNumber] = useState('');
  const [showScanner, setShowScanner] = useState(false);
  const [scanSuccess, setScanSuccess] = useState(false);

  const handleScan = (scannedData) => {
    setSerialNumber(scannedData);
    setShowScanner(false);
    setScanSuccess(true);
    setTimeout(() => setScanSuccess(false), 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!serialNumber.trim()) {
      alert('Please enter or scan a serial number');
      return;
    }
    alert(`Serial Number: ${serialNumber.trim()}`);
  };

  const handleManualInput = (e) => {
    setSerialNumber(e.target.value);
    setScanSuccess(false);
  };

  return (
    <div className="serial-validation-container">
      <div className="card">
        <div className="card-header">
          <h4 className="mb-0">
            <i className="fas fa-barcode me-2"></i>
            Serial Number Validation
          </h4>
        </div>
        <div className="card-body">
          {scanSuccess && (
            <div className="alert alert-success alert-dismissible fade show">
              <i className="fas fa-check-circle me-2"></i>
              Code scanned successfully!
              <button
                type="button"
                className="btn-close"
                onClick={() => setScanSuccess(false)}
              ></button>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="serialNumber" className="form-label">
                <strong>Serial Number</strong>
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-hashtag"></i>
                </span>
                <input
                  type="text"
                  className={`form-control ${scanSuccess ? 'border-success' : ''}`}
                  id="serialNumber"
                  value={serialNumber}
                  onChange={handleManualInput}
                  placeholder="Enter serial number manually"
                  required
                />
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => setShowScanner(true)}
                  disabled={isLoading}
                >
                  <i className="fas fa-qrcode me-2"></i>
                  Scan Code
                </button>
              </div>
              <div className="form-text">
                <i className="fas fa-info-circle me-1"></i>
                You can type manually or scan QR codes and barcodes
              </div>
            </div>

            {stageData && (
              <div className="mb-4">
                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="card-title">Product Information</h6>
                    <div className="row">
                      <div className="col-md-6">
                        <small><strong>Product:</strong> {stageData.product_name}</small>
                      </div>
                      <div className="col-md-6">
                        <small><strong>Model:</strong> {stageData.model_number}</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="d-grid">
              <button
                type="submit"
                className="btn btn-primary btn-lg"
                disabled={!serialNumber.trim() || isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Validating...
                  </>
                ) : (
                  <>
                    <i className="fas fa-check me-2"></i>
                    Validate Serial Number
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      <QRScanner
        isOpen={showScanner}
        onScan={handleScan}
        onClose={() => setShowScanner(false)}
      />
    </div>
  );
};

export default SerialNumberValidation;
